import { render } from "./ChartDisc2LinWidget.vue?vue&type=template&id=2a8bf6c4&ts=true"
import script from "./ChartDisc2LinWidget.vue?vue&type=script&lang=ts"
export * from "./ChartDisc2LinWidget.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/AreaClienti_SELENIA/AreaClienti_SELENIA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__